import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { addDays, addMonths, addYears } from "date-fns";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const EditWarranty = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [warranty, setWarranty] = useState([]);
  const [warrantyTypeData, setWarrantyTypeData] = useState([]);
  const navigate = useNavigate();
  const [warrantycategory, setWarrantyCategory] = useState([]);

  const Token = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    warrantyType();
    warrantyCategory();
  }, []);

  const warrantyType = async () => {
    try {
      const payload = {
        business_partner_id: 1,
      };

      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantytype",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        },
      );

      const data = response.data.data.data;
      const warrantyTypeOptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyTypeData(warrantyTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const warrantyCategory = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantycategory",
        {}, // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        },
      );

      const data = response.data.data.data;
      const warrantycategoryoptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyCategory(warrantycategoryoptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // Prepare the payload
    const payload = {
      warranty_type: formData.warrentytype,
      warranty_category: "Y",
      warranty_name: formData.warranty_name,
      warranty_value: formData.warrantyvalue,
      warranty_desc: formData.warranty_desc,
      status: formData.status === true ? 1 : 0,
      isReplacementWarranty: formData.isReplacementWarranty,
      // warranty_replace_value: formData.warranty_replace_value,
      ...(formData.isReplacementWarranty && {
        warranty_replace_value: formData.warranty_replace_value,
      }),
    };

    const confirmation = await Swal.fire({
      title: "Update Warranty",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);

        await axiosInstance.patch(
          `/warranty/update/${data.warranty_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Token}`,
            },
          },
        );
        await Swal.fire({
          title: "Success",
          text: "Warranty updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        navigate(ROUTES_NAVIGATION.WARRANTY);
      } catch (error) {
  console.log("FULL ERROR:", error.response?.data);

  const errorMessage =
    error.response?.data?.data?.[0]?.message || // ✅ correct path
    error.response?.data?.message ||           // fallback (if API changes)
    "An error occurred while processing your request.";

  await Swal.fire({
    title: "Something went wrong",
    text: errorMessage,
    icon: "error",
    confirmButtonText: "OK",
  });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate(ROUTES_NAVIGATION.WARRANTY);
  };

  const fetchWarranty = async () => {
    try {
      const response = await axiosInstance.get(
        `/warranty/edit/${data.warranty_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      const fetchedData = response.data.data;
      setFormData({
        business_partner_id: fetchedData.business_partner_id,
        warrentytype: fetchedData.warranty_type,
        warrantycategory: 2,
        warranty_name: fetchedData.warranty_name,
        warrantyvalue: fetchedData.warranty_value,
        warranty_desc: fetchedData?.warranty_desc,
        isReplacementWarranty:
          fetchedData.isReplacementWarranty === 1 ? true : false,
        warranty_replace_value: fetchedData.warranty_replace_value,
        status: fetchedData.status === 1 ? true : false,
      });
      setWarranty(fetchedData);
      console.log(fetchedData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWarranty();
  }, []);

  const CustomerInputs = [
    {
      name: "warranty_name",
      label: "Warranty",
      type: "text",
      placeholder: "Enter Warranty Name",
      required: true,
      validation: validations.warrantyName({ required: true }),
      // validation: {
      //   required: true,
      //   pattern: /^[A-Za-z0-9\s]*$/,
      //   message: "Only alphabets and digits are allowed*",
      // },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "warrantycategory",
    //   label: "Warranty Category",
    //   type: "dropdown",
    //   required: true,
    //   options: warrantycategory,
    //   validation: { required: true },
    //   gridClass: "col-lg-4",
    // },
    // ...(formData?.warrantycategory === "Y"
    //   ? [
    {
      name: "warrentytype",
      label: "Warranty Type",
      placeholder: "Enter Warranty Value",
      type: "dropdown",
      options: warrantyTypeData,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    //   ]
    // : []),
    {
      name: "warrantyvalue",
      label: "Warranty Repair Period",
      type: "number",
      placeholder: "Enter Period",
      required: true,
      validation: validations.warrantyValue({ required: true }),
      gridClass: "col-lg-4",
    },

    {
      name: "warranty_desc",
      label: "Warranty Description",
      type: "text",
      placeholder: "Enter Warranty Description",
      required: true,
      validation: validations.description({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "isReplacementWarranty",
      label: "Is Warranty Replaceable?",
      type: "toggle",
      gridClass: "col-lg-4",
    },
    ...(formData?.isReplacementWarranty === true
      ? [
          {
            name: "warranty_replace_value",
            label: "Warranty Replacement Period",
            type: "number",
            placeholder: "Enter Period",
            required: true,
            validation: validations.warrantyValue({ required: true }),
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
  ];

  useEffect(() => {
    // Ensure that warranty_form, warranty_type, and warranty_value are present
    if (
      formData?.warranty_form &&
      formData?.warranty_type &&
      formData?.warranty_value
    ) {
      console.log(
        "Warranty type, value, and form selected",
        formData?.warranty_type,
        formData?.warranty_value,
        formData?.warranty_form,
      );

      // Parse warranty_form into a valid date object
      const warrantyFromDate = new Date(formData?.warranty_form);

      // Check if the date is valid
      if (isNaN(warrantyFromDate.getTime())) {
        console.error("Invalid warranty_form date");
        return;
      }

      let warrantyToDate;

      // Perform calculations based on warranty_type
      switch (formData?.warranty_type) {
        case "D": // Days
          warrantyToDate = addDays(
            warrantyFromDate,
            parseInt(formData?.warranty_value, 10),
          );
          break;
        case "M": // Months
          warrantyToDate = addMonths(
            warrantyFromDate,
            parseInt(formData?.warranty_value, 10),
          );
          break;
        case "Y": // Years
          warrantyToDate = addYears(
            warrantyFromDate,
            parseInt(formData?.warranty_value, 10),
          );
          break;
        default:
          console.error("Invalid warranty type");
          return;
      }

      // Update the formData with the calculated warranty_to date, formatted as YYYY-MM-DD
      setFormData((prevData) => ({
        ...prevData,
        warranty_to: warrantyToDate?.toISOString().split("T")[0], // Format to YYYY-MM-DD
      }));
    }
  }, [
    formData?.warranty_form,
    formData?.warranty_type,
    formData?.warranty_value,
  ]);

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Update Warranty</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the warranty details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>

            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(CustomerInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  CustomerInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditWarranty;
